import {
  TUTORIAL_LOAD_ALL_VIDEOS_BEGIN,
  TUTORIAL_LOAD_ALL_VIDEOS_SUCCESS,
  TUTORIAL_LOAD_ALL_VIDEOS_FAILURE,
  TUTORIAL_LOAD_ALL_VIDEOS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import cookie from 'react-cookies';

export function loadAllVideos(args = {}) {
  return dispatch => {
    dispatch({
      type: TUTORIAL_LOAD_ALL_VIDEOS_BEGIN,
    });

    let config = {
      headers: {
        Authorization: 'Bearer ' + cookie.load('token'),
      },
    };

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE}video-tutorial/active`,
        config,
      );
      doRequest.then(
        res => {
          dispatch({
            type: TUTORIAL_LOAD_ALL_VIDEOS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        err => {
          dispatch({
            type: TUTORIAL_LOAD_ALL_VIDEOS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadAllVideosError() {
  return {
    type: TUTORIAL_LOAD_ALL_VIDEOS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case TUTORIAL_LOAD_ALL_VIDEOS_BEGIN:
      return {
        ...state,
        loadAllVideosPending: true,
        loadAllVideosError: null,
      };

    case TUTORIAL_LOAD_ALL_VIDEOS_SUCCESS:
      return {
        ...state,
        loadAllVideosPending: false,
        loadAllVideosError: null,
        videoListWithCategory: action.data.data ? action.data.data : [],
      };

    case TUTORIAL_LOAD_ALL_VIDEOS_FAILURE:
      return {
        ...state,
        loadAllVideosPending: false,
        loadAllVideosError: action.data.error,
      };

    case TUTORIAL_LOAD_ALL_VIDEOS_DISMISS_ERROR:
      return {
        ...state,
        loadAllVideosError: null,
      };

    default:
      return state;
  }
}
